import React, { ReactFragment } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { SnackbarContent, makeStyles } from '@material-ui/core';
import { buttonPrimaryColor, errorColor } from 'theme/theme';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  error: {
    backgroundColor: errorColor,
  },
  success: {
    backgroundColor: buttonPrimaryColor(),
  },
}));

type SnackProps = {
  isOpen: boolean;
  handleClose: () => void;
  action?: ReactFragment;
  message?: string;
  variant?: string;
};

const SnackbarComponent = (props: SnackProps) => {
  const { handleClose, isOpen, action, message, variant } = props;
  const classes = useStyles();

  const snackbarStyles = clsx({
    [classes.error]: variant === 'error',
    [classes.success]: variant === 'success',
  });

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={isOpen}
      onExited={handleClose}
      onClose={handleClose}
    >
      <SnackbarContent
        message={message}
        action={action}
        className={snackbarStyles}
      ></SnackbarContent>
    </Snackbar>
  );
};

export { SnackbarComponent };
